/* eslint-disable @typescript-eslint/naming-convention */
export interface Activity {
  achievement_count: number;
  id: number;
  isFavorite: boolean;
  isSelected: boolean;
  name: string;
  distance: number;
  moving_time: number;
  elapsed_time: number;
  kudos_count: number;
  achievements: Achievement[];
  segments: any[];
  start_date_local: Date;
  start_date: Date;
  // eslint-disable-next-line max-len
  type:
    | 'AlpineSki'
    | 'BackcountrySki'
    | 'Canoeing'
    | 'Crossfit'
    | 'EBikeRide'
    | 'Elliptical'
    | 'Golf'
    | 'Handcycle'
    | 'Hike'
    | 'IceSkate'
    | 'InlineSkate'
    | 'Kayaking'
    | 'Kitesurf'
    | 'NordicSki'
    | 'Ride'
    | 'RockClimbing'
    | 'RollerSki'
    | 'Rowing'
    | 'Run'
    | 'Sail'
    | 'Skateboard'
    | 'Snowboard'
    | 'Snowshoe'
    | 'Soccer'
    | 'StairStepper'
    | 'StandUpPaddling'
    | 'Surfing'
    | 'Swim'
    | 'Velomobile'
    | 'VirtualRide'
    | 'VirtualRun'
    | 'Walk'
    | 'WeightTraining'
    | 'Wheelchair'
    | 'Windsurf'
    | 'Workout'
    | 'Yoga';
  read: boolean;
  laps: Lap[];
  comment_count: number;
  start_latlng: number[];
  end_latlng: number[];
  start_longitude: number;
  start_latitude: number;
  segment_efforts: any[];
  best_efforts: any[];
  average_heartrate: number;
  calories: number;
  total_elevation_gain: number;
  max_speed: number;
  average_speed: number;
  max_heartrate: number;
  max_watts: number;
  average_watts: number;
  average_cadence: number;
  map: {
    polyline: string;
    summary_polyline: string;
  };
  location_country: string;
  location_city: string;
  location: {
    neighbourhood: string;
    country: string;
    city: string;
  };
  pace: number;
  photos: {
    primary: {
      urls: {
        600: string;
      };
    };
  };
  splits_metric: Lap[];
  splits_standard: Lap[];
  elevation: number[];
  utc_offset: number;
  minutes: string;
  streams: Stream[];
}

export interface Club {
  name: string;
  profilePhoto: string;
  verified: boolean;
  profile: string;
}

export interface Achievement {
  distance: number;
  moving_time: number;
  name: string;
  pr_rank: number;
  rank: number;
  type: string;
  type_id: number;
}

export interface ActivityComment {
  id: number;
  activity_id: number;
  post_id: any;
  resource_state: number;
  text: string;
  mentions_metadata: null;
  created_at: Date;
  athlete: {
    firstname: string;
    lastname: string;
  };
  selected: boolean;
}

export interface Lap {
  name: string;
  moving_time: number;
  distance: number;
  selected: boolean;
  pace: number;
  max_heartrate?: number;
  average_heartrate?: number;
  total_elevation_gain?: number;
  extended?: boolean;
  elevation_difference?: number;
  mergedLaps?: Lap[];
  average_speed?: number;
}

export interface Preselected {
  names: string[];
  stickers: any[];
}
export interface ModalData {
  data: any;
  type:
  | 'title'
  | 'map'
  | 'laps'
  | 'charts'
  | 'comments'
  | 'stickers'
  | 'trophies'
  | 'camera'
  | 'table'
  | 'user'
  | 'video'
  | 'analysis';
  color: any;
}

export interface Stream {
  data: number[][] | number[];
  original_size?: number[];
  resolution?: string;
  series_type?: string;
  type: string;
  hidden?: boolean;
  borderColor?: string;
  labelColor?: string;
  fontColor?: string;
}

export const ActivityIcons = {
  AlpineSki: '',
  BackcountrySki: '',
  Canoeing: '',
  Crossfit: '',
  EBikeRide: '',
  Elliptical: '',
  Golf: '',
  Handcycle: '',
  Hike: '',
  IceSkate: '',
  InlineSkate: '',
  Kayaking: '',
  Kitesurf: '',
  NordicSki: '',
  Ride: '',
  RockClimbing: '',
  RollerSki: '',
  Rowing: '',
  Run: '',
  Sail: '',
  Skateboard: '',
  Snowboard: '',
  Snowshoe: '',
  Soccer: '',
  StairStepper: '',
  StandUpPaddling: '',
  Surfing: '',
  Swim: '',
  Velomobile: '',
  VirtualRide: '',
  VirtualRun: '',
  Walk: '',
  WeightTraining: '',
  Wheelchair: '',
  Windsurf: '',
  Workout: '',
  Yoga: '',
};

export const Flags = {
  Afghanistan: 'AF',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua and Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  'The Bahamas': 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  'Bolivia (Plurinational State of)': 'BO',
  'Bonaire, Sint Eustatius and Saba': 'BQ',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  'Cabo Verde': 'CV',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  'Congo (the Democratic Republic of the)': 'CD',
  Congo: 'CG',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  Croatia: 'HR',
  Cuba: 'CU',
  Curaçao: 'CW',
  Cyprus: 'CY',
  Czechia: 'CZ',
  'Côte d\'Ivoire': 'CI',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Eswatini: 'SZ',
  Ethiopia: 'ET',
  'Falkland Islands [Malvinas]': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island and McDonald Islands': 'HM',
  'Holy See': 'VA',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  'Iran (Islamic Republic of)': 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  'Korea (the Democratic People\'s Republic of)': 'KP',
  'Korea (the Republic of)': 'KR',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  'Lao People\'s Democratic Republic': 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  'Micronesia (Federated States of)': 'FM',
  'Moldova (the Republic of)': 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestine, State of': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  'Republic of North Macedonia': 'MK',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  Réunion: 'RE',
  'Saint Barthélemy': 'BL',
  'Saint Helena, Ascension and Tristan da Cunha': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin (French part)': 'MF',
  'Saint Pierre and Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome and Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  'Sint Maarten (Dutch part)': 'SX',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia and the South Sandwich Islands': 'GS',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard and Jan Mayen': 'SJ',
  Sweden: 'SE',
  Switzerland: 'CH',
  'Syrian Arab Republic': 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  'Tanzania, United Republic of': 'TZ',
  Thailand: 'TH',
  'Timor-Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks and Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'Great Britain': 'GB',
  'United Kingdom of Great Britain and Northern Ireland': 'GB',
  'United States Minor Outlying Islands': 'UM',
  'United States of America': 'US',
  USA: 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  'Venezuela (Bolivarian Republic of)': 'VE',
  Venezuela: 'VE',
  'Viet Nam': 'VN',
  'British Virgin Islands': 'VG',
  'Virgin Islands (British)': 'VG',
  'US Virgin Islands': 'VI',
  'Virgin Islands (U.S.)': 'VI',
  'Wallis and Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
  'Åland Islands': 'AX',
  null: '',
};


export interface BoundingBox {
  top: number;
  left: number;
  right: number;
  bottom: number;
}

export interface SnapLines {
  vertical: Set<number>;
  horizontal: Set<number>;
}
